import { useEffect, useState } from 'react';

import { Box, Grid, Typography } from '@mui/material';
import { t } from 'i18n';
import Lottie from 'lottie-react';

import logoSW from 'assets/img/brand/logo-studyworks-origineel1.png';
import logoOB from 'assets/img/brand/LOGO_OB.png';
import logoBEU from 'assets/img/brand/LogoBijlesEU.png';
import logoVBL from 'assets/img/brand/VlakbijlesLogo.png';
import useLabel from 'functions/Hooks/useLabel';
import { LottieJson } from 'theme-constants';

const Maintenance = () => {
  const label = useLabel();
  const [logo, setLogo] = useState<string>();
  const [height, setHeight] = useState<string>();

  /** Set states (logo, margin and height) for the logo based on label */
  useEffect(() => {
    if (label) {
      switch (label?.name) {
        case 'StudyWorks':
          setLogo(logoSW);
          setHeight('30px');
          break;
        case 'VlakBijles':
          setLogo(logoVBL);
          setHeight('80px');
          break;
        case 'bijleseu.nl':
          setLogo(logoBEU);
          setHeight('80px');
          break;
        case 'Bijles.EU':
          setLogo(logoBEU);
          setHeight('60px');
          break;
        case 'Online-Bijles.com':
          setLogo(logoOB);
          setHeight('80px');
          break;
        default:
          break;
      }
    }
  }, [label]);

  return (
    <Grid
      container
      spacing={{ xs: 2, sm: 6 }}
      justifyContent={{ xs: 'flex-start', sm: 'center' }}
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      height={{ xs: 'auto', sm: '100vh' }}
      padding={{ xs: '24px', sm: '0px 30vh 20vh 30vh' }}>
      <Grid item xs={12}>
        <img
          src={logo}
          style={{
            height: height,
            objectFit: 'contain',
          }}
        />
      </Grid>
      <Grid item xs={12} sm={7}>
        <Typography variant="h1" color="text.secondary">
          {t('translation.maintenance.title')}
        </Typography>
        <Typography variant="h4" color="text.secondary">
          {t('translation.maintenance.text')}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={5}>
        <Box
          sx={{
            maxHeight: '80vw',
            maxWidth: '80vw',
            margin: 'auto',
            marginTop: { xs: '48px', sm: 'unset' },
          }}>
          <Lottie
            animationData={LottieJson.maintenance}
            loop
            autoplay
            rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default Maintenance;
